import { HttpTask } from '@core/http';
import httpService from '@core/http/service';
import { CreateTicketParams, Ticket } from '@modules/ticket/model';
import { NextPageContext } from 'next';

const URI = '/tickets';

export function getSerials(search: string | null, ctx?: NextPageContext): HttpTask<Array<string>> {
  return httpService.get(`${URI}/serials`, ctx, { params: { search } });
}

export function checkSerial(equipmentSerialId: string): HttpTask {
  return httpService.post(`${URI}/${equipmentSerialId}/check`);
}

export function createTicket(equipmentSerialId: string, params: CreateTicketParams): HttpTask<Ticket> {
  return httpService.post(`${URI}/${equipmentSerialId}`, params);
}

export function getTicket(ticketNumber: string, ctx: NextPageContext): HttpTask<Ticket> {
  return httpService.get(`${URI}/${ticketNumber}`, ctx);
}
